import { Observable, Subscriber } from 'rxjs';

export function createFileByPath(
  path: string,
  name: string = 'default.png',
  type: string = 'image/png'
): Observable<File> {
  return new Observable((subscriber: Subscriber<File>) => {
    fetch(path)
      .then((response: Response) => response.blob())
      .then((data: Blob) => {
        const file = new File([data], name, { type: type });
        subscriber.next(file);
      })
      .catch((error) => subscriber.error(error))
      .finally(() => subscriber.complete());
  });
}

export function isFileExistInArray(file: File, files: File[]): boolean {
  return !!files.find((f: File): boolean => compareFiles(f, file));
}

export function compareFiles(file1: File, file2: File): boolean {
  return (
    file1.name == file2.name &&
    file1.size == file2.size &&
    file1.lastModified == file2.lastModified
  );
}
